import React from 'react';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <div className="lc-footer-inner">
      <div className="lc-footer-meta">
        <div>© {year} LockChain.</div>
        <div>Unified LUKS &amp; ZFS key management for operators who care about early-boot clarity.</div>
      </div>

      <div className="lc-footer-links">
        <a
          href="https://github.com/x4ngus/lockchain"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
        <a
          href="https://github.com/x4ngus/lockchain/tree/main/docs"
          target="_blank"
          rel="noopener noreferrer"
        >
          Docs
        </a>
        <a
          href="https://github.com/x4ngus/lockchain/security"
          target="_blank"
          rel="noopener noreferrer"
        >
          Security policy
        </a>
      </div>
    </div>
  );
};

export default Footer;
